import { render } from "./page-smart-house.vue?vue&type=template&id=3339bf24&scoped=true"
import script from "./page-smart-house.vue?vue&type=script&lang=js"
export * from "./page-smart-house.vue?vue&type=script&lang=js"

import "./page-smart-house.vue?vue&type=style&index=0&id=3339bf24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3339bf24"]])

export default __exports__